import { z } from "zod";

export const reprocessingStageSchema = z.enum(["parser", "correlation"]);
export const preparationJobSchema = z.object({
  job_id: z.uuid(), row_version: z.number().int().positive(),
  status: z.string(), parser_status: z.string(), correlation_status: z.string(), enrichment_status: z.string(),
  last_error_code: z.string().nullable(), analysis_run_id: z.uuid().nullable(),
  updated_at: z.string(), retryable_stages: z.array(reprocessingStageSchema),
  stage_errors: z.partialRecord(z.enum(["parser", "correlation", "enrichment"]), z.string()),
});
export const reprocessingReceiptSchema = z.object({
  request_id: z.uuid(), job_id: z.uuid(), stage: reprocessingStageSchema,
  row_version: z.number().int().positive(), requested_at: z.string(),
});
export type PreparationJob = z.infer<typeof preparationJobSchema>;
export type ReprocessingStage = z.infer<typeof reprocessingStageSchema>;
